import { Box, Container } from '@mui/material';
import React from 'react';
import AlertSnackbar from './AlertSnackbar';
import Logo from './Logo';

function AuthPageWrapper({ alert, onCloseAlert, children }) {
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Logo />
      <Container sx={{ maxWidth: 428, pb: 5 }}>
        <AlertSnackbar {...alert} onClose={onCloseAlert} />
        {children}
      </Container>
    </Box>
  );
}

export default AuthPageWrapper;
